import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_NHSV_ORDER_HISTORY_API_ID =
  'DASHBOARD/FETCH_NHSV_ORDER_HISTORY_API';

const apiCall = createApiCall(
  FETCH_NHSV_ORDER_HISTORY_API_ID,
  (params: {
    account_number: string;
    from_date?: string;
    to_date?: string;
    next_date?: string;
    next_key?: string;
  }) => ({
    endpoint: generateEndpoint({
      host: '/api/admin/nhsv/order-history',
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
